import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../services';
import { PersonDialog } from '../../../person-dialog';
import { AccSessionViewerDialogDataService } from '../acc-session-viewer-dialog-data.service';

@Component({
	selector: 'acc-session-details-part',
	standalone: true,
	templateUrl: './details.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './details.part.scss'
})
export class AccSessionDetailsPart {

	private readonly dialogDataService = inject(AccSessionViewerDialogDataService);
	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly domainData = inject(DomainDataService);
	private readonly dialog = inject(DialogService);

	public readonly accSessionDetails = computed(() => {
		const details = this.dialogDataService.accSessionDetails();

		if (!details) return undefined;
		return {
			...details,
			topicName: this.domainData.data().topicsMap[details.topicId]?.name,
			trimesterName: this.app.getTrimesterNameById(details.trimesterId),
			timezone: this.util.date.getTimezoneToDisplay(),
			eventStartDate: this.util.date.formatUTCByUserTimeZone(details.startUTC, 'MMM D, YYYY', 'H:MM AM EST', "en-US"),
			eventEndDate: this.util.date.formatUTCByUserTimeZone(details.endUTC!, 'MMM D, YYYY', 'H:MM AM EST', "en-US"),
			language: details.languageId === LanguageId.English ? 'English' : 'Spanish',
			facilitator: this.app.staffDataMap()[details.facilitatorStaffId],
		}
	});

	public openPersonDialog(personId: number) {
		this.dialog.showCustom(PersonDialog, { data: { personId, toEdit: false } }, 800, 800);
	}

}